module.exports = __webpack_public_path__ + "img/33d4635.svg";